<template>
  <div>
    <b-card
      no-body
      class="mb-2"
    >
      <b-card-body class="d-flex flex-wrap align-items-center">
        <div class="mr-auto">
          <h4 class="mb-25">
            Rescan Jobs
          </h4>
          <div class="text-muted font-small-3">
            Son yenileme: {{ formatDate(lastRefreshedAt) }} · Otomatik yenileme 3 sn
          </div>
        </div>

        <div class="job-counts d-flex flex-wrap align-items-center mr-1">
          <b-badge
            variant="light-primary"
            class="mr-50"
          >
            Çalışan {{ counts.running }}
          </b-badge>
          <b-badge
            variant="light-warning"
            class="mr-50"
          >
            Bekleyen {{ counts.queued }}
          </b-badge>
          <b-badge variant="light-secondary">
            İptal bekleyen {{ counts.cancelRequested }}
          </b-badge>
        </div>

        <b-button
          variant="outline-primary"
          :disabled="loading"
          @click="refresh(false)"
        >
          <b-spinner
            v-if="loading"
            small
          />
          <feather-icon
            v-else
            icon="RefreshCwIcon"
          />
          Yenile
        </b-button>
      </b-card-body>
    </b-card>

    <b-alert
      v-if="notice.message"
      :variant="notice.status ? 'success' : 'danger'"
      show
      dismissible
      class="mb-2"
      @dismissed="clearNotice"
    >
      {{ notice.message }}
    </b-alert>

    <b-card no-body>
      <b-table
        :items="tableRows"
        :fields="fields"
        :busy="loading"
        responsive
        striped
        show-empty
        empty-text="Rescan job bulunamadı."
        class="mb-0"
      >
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle" />
          </div>
        </template>

        <template #cell(status)="data">
          <b-badge :variant="statusVariant(data.item.status)">
            {{ statusLabel(data.item.status) }}
          </b-badge>
          <div
            v-if="data.item.status === 'RUNNING' || data.item.status === 'CANCEL_REQUESTED'"
            class="text-muted font-small-3 mt-25"
          >
            {{ elapsedLabel(data.item.startedAt) }}
          </div>
        </template>

        <template #cell(job)="data">
          <strong>{{ actionLabel(data.item.action) }}</strong>
          <div class="text-muted font-small-3">
            {{ kindLabel(data.item.kind) }} · {{ sourceLabel(data.item.source) }}
          </div>
          <div class="text-muted font-small-2 job-id">
            {{ data.item.id }}
          </div>
        </template>

        <template #cell(result)="data">
          <template v-if="data.item.result && data.item.action === 'FULL_RESCAN'">
            <div>
              {{ number(data.item.result.passed) }} geçti ·
              {{ number(data.item.result.failed) }} elendi
            </div>
            <div class="text-muted font-small-3">
              {{ number(data.item.result.savedEdges) }} edge ·
              {{ durationLabel(data.item.result.durationMs) }}
            </div>
          </template>
          <template v-else-if="data.item.error && data.item.status !== 'CANCELLED'">
            <span class="text-danger">{{ data.item.error }}</span>
          </template>
          <span
            v-else
            class="text-muted"
          >-</span>
        </template>

        <template #cell(timing)="data">
          <div>{{ formatDate(data.item.createdAt) }}</div>
          <div class="text-muted font-small-3">
            Başlangıç: {{ formatDate(data.item.startedAt) }}
          </div>
          <div class="text-muted font-small-3">
            Bitiş: {{ formatDate(data.item.finishedAt) }}
          </div>
        </template>

        <template #cell(actions)="data">
          <b-button
            v-if="canCancel(data.item)"
            size="sm"
            variant="outline-danger"
            :disabled="cancellingId === data.item.id || data.item.status === 'CANCEL_REQUESTED'"
            @click="confirmCancel(data.item)"
          >
            <b-spinner
              v-if="cancellingId === data.item.id"
              small
            />
            <feather-icon
              v-else
              icon="XCircleIcon"
            />
            {{ data.item.status === 'CANCEL_REQUESTED' ? 'Bekleniyor' : 'İptal' }}
          </b-button>
          <span
            v-else
            class="text-muted"
          >-</span>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BAlert,
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BSpinner,
  BTable,
} from 'bootstrap-vue'

export default {
  components: {
    BAlert,
    BBadge,
    BButton,
    BCard,
    BCardBody,
    BSpinner,
    BTable,
  },
  data() {
    return {
      timer: null,
      lastRefreshedAt: null,
      fields: [
        {
          key: 'status', label: 'Durum', sortable: true, thClass: 'width-130',
        },
        { key: 'job', label: 'Job', sortable: true },
        { key: 'result', label: 'Sonuç', sortable: false },
        {
          key: 'timing', label: 'Zaman', sortable: true, thClass: 'width-220',
        },
        {
          key: 'actions', label: '', sortable: false, thClass: 'width-110',
        },
      ],
    }
  },
  computed: {
    jobs() { return this.$store.getters['rescanJobs/jobs'] || [] },
    loading() { return this.$store.getters['rescanJobs/loading'] },
    cancellingId() { return this.$store.getters['rescanJobs/cancellingId'] },
    notice() { return this.$store.getters['rescanJobs/notice'] || {} },
    tableRows() { return this.jobs },
    counts() {
      return this.jobs.reduce((result, job) => {
        if (job.status === 'RUNNING') result.running += 1
        if (job.status === 'QUEUED') result.queued += 1
        if (job.status === 'CANCEL_REQUESTED') result.cancelRequested += 1
        return result
      }, { running: 0, queued: 0, cancelRequested: 0 })
    },
  },
  created() {
    this.refresh(false)
    this.timer = window.setInterval(() => this.refresh(true), 3000)
  },
  beforeDestroy() {
    if (this.timer) window.clearInterval(this.timer)
  },
  methods: {
    refresh(silent) {
      return this.$store.dispatch('rescanJobs/fetch', { limit: 100, silent })
        .then(() => { this.lastRefreshedAt = new Date() })
        .catch(() => {})
    },
    clearNotice() {
      this.$store.commit('rescanJobs/SET_NOTICE', { status: null, message: null })
    },
    canCancel(job) {
      return ['QUEUED', 'RUNNING', 'CANCEL_REQUESTED'].includes(job.status)
    },
    confirmCancel(job) {
      this.$bvModal.msgBoxConfirm(
        `${this.kindLabel(job.kind)} rescan job iptal edilsin mi?`,
        {
          title: 'Rescan İptali',
          okTitle: 'İptal Et',
          cancelTitle: 'Vazgeç',
          okVariant: 'danger',
          centered: true,
        },
      ).then(confirmed => {
        if (confirmed) this.$store.dispatch('rescanJobs/cancel', job.id)
      })
    },
    statusLabel(status) {
      return {
        QUEUED: 'Bekliyor',
        RUNNING: 'Çalışıyor',
        DONE: 'Tamamlandı',
        FAILED: 'Hatalı',
        CANCEL_REQUESTED: 'İptal bekliyor',
        CANCELLED: 'İptal edildi',
      }[status] || status
    },
    statusVariant(status) {
      return {
        QUEUED: 'warning',
        RUNNING: 'primary',
        DONE: 'success',
        FAILED: 'danger',
        CANCEL_REQUESTED: 'secondary',
        CANCELLED: 'dark',
      }[status] || 'light-secondary'
    },
    actionLabel(action) {
      return action === 'ACTIVE_MAP_REFRESH' ? 'Aktif Edge Haritası' : 'Tam Rescan'
    },
    kindLabel(kind) {
      return kind === 'QUICK_GAIN' ? 'Quick Scan' : 'Edge Scan'
    },
    sourceLabel(source) {
      const labels = {
        manual_trigger: 'Manuel tetik',
        scheduled_job: 'Periyodik',
        indicator_auto_selection: 'İndikatör seçici',
        manual_active_map_refresh: 'Manuel aktif harita',
        tp_sl_recommendation_apply: 'TP/SL önerisi',
      }
      return labels[source] || source || 'Sistem'
    },
    number(value) {
      return Number(value || 0).toLocaleString('tr-TR')
    },
    formatDate(value) {
      if (!value) return '-'
      const date = new Date(value)
      return Number.isNaN(date.getTime()) ? '-' : date.toLocaleString('tr-TR')
    },
    durationLabel(ms) {
      const seconds = Math.max(0, Math.round(Number(ms || 0) / 1000))
      if (seconds < 60) return `${seconds} sn`
      return `${Math.floor(seconds / 60)} dk ${seconds % 60} sn`
    },
    elapsedLabel(startedAt) {
      if (!startedAt) return 'Başlatılıyor'
      return `${this.durationLabel(Date.now() - new Date(startedAt).getTime())} çalıştı`
    },
  },
}
</script>

<style lang="scss" scoped>
.job-id {
  overflow-wrap: anywhere;
}

.job-counts {
  min-height: 34px;
}
</style>
